export default __webpack_public_path__ + "static/media/avesidLogo.c10d2645.png";